module.exports = __webpack_public_path__ + "img/theme15.6eca9310.png";